/* eslint-disable @next/next/no-img-element */
import React, { FC, memo, useEffect, useState } from 'react'
import * as S from './styles'
import { SelectProps } from './types'

export const CustomSelect: FC<SelectProps> = memo(
  ({
    id,
    label = '',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    required = false,
    error = '',
    hasError = false,
    isBlock = false,
    isInline = false,
    disabled = false,
    readOnly = false,
    className = '',
    options,
    placeholder = '',
    propertyValue = 'id',
    keepPlaceholder = false,
    propertyLabel = 'name',
    style,
    value,
    noSelectIco,
    cursor,
    onChange,
    noBorder,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ...rest
  }) => {
    const [selectedOption, setSelectedOption] = useState(null)
    const [isOpen, setIsOpen] = useState(false)
    const handleOptionClick = (option) => {
      setSelectedOption(option)
      setIsOpen(false)

      onChange && onChange({ target: { value: option } } as React.ChangeEvent<HTMLSelectElement>)
    }

    // Handles outside click to hide preview components
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as HTMLElement | null

        if (target && !target.closest('.custom-select-item')) {
          setIsOpen(false)
        }
      }

      // Adding event listener to the document
      document.addEventListener('click', handleClickOutside)

      // Cleanup event listener on component unmount
      return () => {
        document.removeEventListener('click', handleClickOutside)
      }
    }, [])

    return (
      <S.Container isBlock={isBlock} isInline={isInline} className={className || ''} style={style} cursor={cursor}>
        {label && <label htmlFor={id}>{label}</label>}
        <S.Group isInline={isInline} hasError={hasError} disabled={disabled} readOnly={readOnly} noBorder={noBorder}>
          <div
            className={isOpen ? 'selected-option selected-option-open' : 'selected-option'}
            onClick={() => !disabled && setIsOpen(!isOpen)}
          >
            {!noSelectIco && (
              <span className='selected-ico'>
                <img src='/icons/shipping.svg'></img>
              </span>
            )}

            {!keepPlaceholder ? (
              <>
                {!selectedOption && <span>{placeholder}</span>}
                {options.map((option) => {
                  if (option.id === value) {
                    return <span key={`key_${option.id}`}>{option[propertyLabel]}</span>
                  }
                  return null
                })}
              </>
            ) : (
              <span>{placeholder}</span>
            )}
            {/* {!selectedOption && <span>{placeholder}</span>} */}
            <span className='arrow-small-set'>
              <img src='/icons/arrow-down-small.svg'></img>
            </span>
          </div>
          {isOpen && (
            <div className='options'>
              {options.map((option) => (
                <div
                  key={option[propertyValue]}
                  data-value={option[propertyValue]}
                  className={value === option[propertyValue] ? 'each-option each-option-current' : 'each-option'}
                  onClick={() => handleOptionClick(option[propertyValue])}
                >
                  <img src={option.icon} alt={option.label} />
                  <span>{option[propertyLabel]}</span>
                </div>
              ))}
            </div>
          )}
          {/* <select
          id={id}
          required={required}
          aria-required={required}
          aria-disabled={disabled}
          disabled={disabled}
          {...rest}
        >
          {placeholder && <option value=''>{placeholder}</option>}
          {options &&
            options.length > 0 &&
            options.map((option) => (
              <option key={option[propertyValue]} value={option[propertyValue]}>
                <i className='fas fa-coffee'>sd</i> {option[propertyLabel]}
              </option>
            ))}
        </select> */}
        </S.Group>
        {error && <S.Error>{error}</S.Error>}
      </S.Container>
    )
  }
)

CustomSelect.displayName = 'CustomSelect'
